module.exports = __webpack_public_path__ + "res/roboto-v15-latin-300.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-300.woff2
// module id = 98
// module chunks = 1